import { ChangeDetectorRef, Component, OnInit, } from '@angular/core';
import { Router, RouterLink } from "@angular/router";
import { DialogModule } from "primeng/dialog";
import { InputTextModule } from "primeng/inputtext";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { PasswordModule } from "primeng/password";
import { take } from 'rxjs';
import { NotificationService } from "../service/notification.service";
import { SocketService } from '../service/socket.service';
import { UserService } from "../service/user.service";
import { AuthService } from "../service/auth.service";
import { NavigationService } from "../service/navigation.service";
import { IUser } from "../interfaces/IUser";
import { environment } from "../../environments/environment";
import { ToastModule } from "primeng/toast";
import { EventS } from "../service/event.s";
import { NgIf } from "@angular/common";
import { FloatLabelModule } from "primeng/floatlabel";

@Component({
    selector: 'app-login-dialog',
    standalone: true,
    imports: [RouterLink, DialogModule, InputTextModule, ReactiveFormsModule, PasswordModule, ToastModule, NgIf, FloatLabelModule],
    templateUrl: './login-dialog.component.html',
    styleUrl: './login-dialog.component.scss'
})
export class LoginDialogComponent implements OnInit {
    visible: boolean = false;
    loading = { form: false };
    form: FormGroup | any;
    forgotPassForm: FormGroup | any;
    loginForm: boolean = true;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    constructor(private fb: FormBuilder,
                public userS: UserService,
                public authService: AuthService,
                public navigationService: NavigationService,
                public router: Router,
                public eventS: EventS,
                public ns: NotificationService,
                public socketService: SocketService,
                public cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.createForm();
        this.eventS.openLoginDialog.subscribe(open => {
            if (open) {
                this.showDialog();
                this.eventS.openLoginDialog.next(false);
            }
        });
    }

    createForm() {
        this.form = this.fb.group({
            usr_userName_str: <any>['', Validators.required],
            usr_pass_str: ['', Validators.required],
            // email: <any>['', Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])],
        });
        this.forgotPassForm = this.fb.group({
            usr_email_str: <any>['', Validators.required],
        });
    }

    showDialog() {
        this.visible = true;
    }

    async login() {
        const formData: IUser = this.form.getRawValue();
        if (this.form.invalid) return this.ns.showError('Please fill all required fields');
        this.loading.form = true;
        setTimeout(async () => {
            try {
                const user = <any>await this.userS.login(formData.usr_userName_str, formData.usr_pass_str);
                if (user === null || user === '' || user === '') {
                    this.loading.form = false;
                    return this.ns.showError('You have entered an invalid username or password');
                }
                if (user && user.accessToken) {
                    this.ns.showSuccess('Login Success.');
                    this.authService.token.accessToken = user.accessToken;
                    this.authService.token.refreshToken = user.refreshToken;
                    this.authService.setUserToLocalStorage(user, environment.crypto.passJWT);
                    this.socketService.getConnection(<any>this.authService.getUserId());
                    setTimeout(() => {
                        this.visible = false;
                        this.navigationService.gotoDashboard(this.authService.gUser);
                    }, 500);
                } else this.ns.showError(user.message);
                this.loading.form = false;
            } catch (e: any) {
                this.loading.form = false;
                this.ns.showErrorFromResponse(e.error || e, 'Unable to login.');
            }
            this.loading.form = false;
            this.cd.detectChanges();
        }, 200);
        this.cd.detectChanges();
    }

    showRegisterPage() {
        this.router.navigate(['/registration']).then();
        this.visible = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    openForgotPassForm() {
        this.loginForm = false;
    }

    showLoginForm() {
        this.loginForm = true;
    }

    async forgotPassword() {
        const formData: IUser = this.forgotPassForm.getRawValue();
        try {
            let res = await this.userS.forgotPassword(formData);
            if (res) this.ns.showSuccess("Your password has been sent to your email.");
            setTimeout(() => {
                this.loginForm = true;
            }, 500)
        } catch (e: any) {
            this.ns.showErrorFromResponse(e.error || e, `Please try again.`);
        }

    }
}
